module.exports = __webpack_public_path__ + "media/images/payments/clickandbuy-24985a54d9f46fe765003bc2b7a351ce.svg";